import { render } from "./VideoPreviewWidget.vue?vue&type=template&id=38263e90"
import script from "./VideoPreviewWidget.vue?vue&type=script&lang=js"
export * from "./VideoPreviewWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__